const VALUE_TYPES = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_object",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};
const ALL_TYPES = Object.values(VALUE_TYPES);
const ALL_ARRAY_TYPES = [
    VALUE_TYPES.ARRAY,
    VALUE_TYPES.ARRAY_NUMBER,
    VALUE_TYPES.ARRAY_STRING,
    VALUE_TYPES.ARRAY_DATE,
    VALUE_TYPES.ARRAY_OBJECT,
    VALUE_TYPES.ARRAY_BOOLEAN,
];
const filterOperators = [
    { value: "equal", payloadRequired: true, fitTypes: ALL_TYPES },
    { value: "not_equal", payloadRequired: true, fitTypes: ALL_TYPES },
    {
        value: "contain",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, ...ALL_ARRAY_TYPES, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "not_contain",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, ...ALL_ARRAY_TYPES, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "starts_with",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "ends_with",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED, VALUE_TYPES.DATE, VALUE_TYPES.DATETIME],
    },
    { value: "empty", payloadRequired: false, fitTypes: ALL_TYPES },
    { value: "non_empty", payloadRequired: false, fitTypes: ALL_TYPES },
    {
        value: "longer_than",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "shorter_than",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "less_than",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.NUMBER, VALUE_TYPES.MIXED, VALUE_TYPES.DATE, VALUE_TYPES.DATETIME],
    },
    {
        value: "less_or_equal",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.NUMBER, VALUE_TYPES.MIXED, VALUE_TYPES.DATE, VALUE_TYPES.DATETIME],
    },
    {
        value: "greater_than",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.NUMBER, VALUE_TYPES.MIXED, VALUE_TYPES.DATE, VALUE_TYPES.DATETIME],
    },
    {
        value: "greater_or_equal",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.NUMBER, VALUE_TYPES.MIXED, VALUE_TYPES.DATE, VALUE_TYPES.DATETIME],
    },
    {
        value: "in_list",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.NUMBER, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "not_in_list",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.NUMBER, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
    {
        value: "regex",
        payloadRequired: true,
        fitTypes: [VALUE_TYPES.STRING, VALUE_TYPES.ENUM, VALUE_TYPES.MIXED],
    },
];

export default filterOperators;
